// extracted by mini-css-extract-plugin
module.exports = {"error":"style_error__qQJtT","wrap":"style_wrap__80m2Z"};